export const settingRoutes = {
  path: "settings",
  component: () => import("@/pages/settings/ApplicationSettingsContainer.vue"),
  children: [
    {
      path: "address-types",
      name: "address type index",
      meta: {
        label: "Address Types",
      },
      component: () => import("@/pages/settings/types/AddressTypeIndex.vue")
    },
    {
      path: "app-settings",
      name: "settings home",
      meta: {
        label: "Application Settings",
      },
      component: () => import("@/pages/settings/ApplicationSettingsHome.vue")
    },
    {
      path: "export-data",
      name: "export data",
      meta: {
        label: "Export Data"
      },
      component: () => import("@/pages/settings/AppExportData.vue")
    },
    {
      path: "import-data",
      name: "import data",
      meta: {
        label: "Import Data"
      },
      component: () => import("@/pages/settings/AppImportData.vue")
    },
    {
      path: "optimize-app",
      name: "optimize app",
      meta: {
        label: "Optimize App"
      },
      component: () => import("@/pages/settings/AppOptimizeApp.vue")
    },
    {
      path: "areas-of-qualification",
      name: "areas of qualification",
      meta: {
        label: "Areas Of Qualification"
      },
      component: () => import("@/pages/settings/coach/AreasOfQualificationIndex.vue")
    },
    {
      path: "certifications",
      name: "certifications",
      meta: {
        label: "Certifications"
      },
      component: () => import("@/pages/settings/coach/CertificationIndex.vue")
    },
    {
      path: "comment-types",
      name: "comment type index",
      meta: {
        label: "Comment Types",
      },
      component: () => import("@/pages/settings/types/CommentTypeIndex.vue")
    },
    {
      path: "degrees",
      name: "degree index",
      meta: {
        label: "Degrees",
      },
      component: () => import("@/pages/settings/education/DegreeIndex.vue")
    },
    {
      path: "disciplines",
      name: "disciplines",
      meta: {
        label: "Disciplines",
      },
      component: () => import("@/pages/settings/education/DisciplineIndex.vue"),
    },
    {
      path: "document-types",
      name: "document type index",
      meta: {
        label: "Document Types",
      },
      component: () => import("@/pages/settings/types/DocumentTypeIndex.vue")
    },
    {
      path: "email-types",
      name: "email type index",
      meta: {
        label: "Email Types",
      },
      component: () => import("@/pages/settings/types/EmailTypeIndex.vue")
    },
    {
      path: "employers",
      name: "employers",
      meta: {
        label: "Employers",
      },
      component: () => import("@/pages/settings/coach/EmployerIndex.vue"),
    },
    {
      path: "employment-types",
      name: "employment type index",
      meta: {
        label: "Employment Types",
      },
      component: () => import("@/pages/settings/types/EmploymentTypeIndex.vue")
    },
    {
      path: "facilitating-courses",
      name: "facilitating courses",
      meta: {
        label: "Facilitating Courses",
      },
      component: () => import("@/pages/settings/education-experience/FacilitatingCourseIndex.vue"),
    },
    {
      path: "languages",
      name: "languages",
      meta: {
        label: "Languages",
      },
      component: () => import("@/pages/settings/education-experience/LanguageIndex.vue"),
    },
    {
      path: "learning-management-systems",
      name: "lms",
      meta: {
        label: "Learning Management Systems",
      },
      component: () => import("@/pages/settings/education-experience/LearningManagementSystemIndex.vue"),
    },
    {
      path: "issuing-authorities",
      name: "issuing authorities",
      meta: {
        label: "Issuing Authorities",
      },
      component: () => import("@/pages/settings/coach/IssuingAuthorityIndex.vue"),
    },
    {
      path: "invoice-email-body",
      name: "invoice email body",
      meta: {
        label: "Invoice Email Body",
      },
      component: () => import("@/pages/settings/InvoiceEmailBody.vue"),
    },
    {
      path: "masquerade",
      name: "masquerade",
      meta: {
        label: "Masquerade As User",
      },
      component: () => import("@/pages/settings/UserMasquerade.vue"),
    },
    {
      path: "minors",
      name: "minors",
      meta: {
        label: "Minors",
      },
      component: () => import("@/pages/settings/education/MinorIndex.vue"),
    },
    {
      path: "nurse-licenses",
      name: "nurse licenses",
      meta: {
        label: "Nurse Licenses"
      },
      component: () => import("@/pages/settings/coach/NurseLicenseIndex.vue")
    },
    {
      path: "phone-types",
      name: "phone type index",
      meta: {
        label: "Phone Types",
      },
      component: () => import("@/pages/settings/types/PhoneTypeIndex.vue")
    },
    {
      path: "point-of-contact-types",
      name: "point of contact type index",
      meta: {
        label: "Point Of Contact Types",
      },
      component: () => import("@/pages/settings/types/PointOfContactTypeIndex.vue")
    },
    {
      path: "prefixes",
      name: "prefixe index",
      meta: {
        label: "Prefixes",
      },
      component: () => import("@/pages/settings/coach/PrefixIndex.vue")
    },
    {
      path: "referral-sources",
      name: "referral sources",
      meta: {
        label: "Referral Sources",
      },
      component: () => import("@/pages/settings/coach/ReferralSourceIndex.vue"),
    },
    {
      path: "regional-accreditors",
      name: "regional accreditors",
      meta: {
        label: "Regional Accreditors"
      },
      component: () => import("@/pages/settings/university/RegionalAccreditorsIndex.vue")
    },
    {
      path: "specialties",
      name: "specialties",
      meta: {
        label: "Specialties"
      },
      component: () => import("@/pages/settings/coach/SpecialtyIndex.vue")
    },
    {
      path: "status-explanations",
      name: "status explanations",
      meta: {
        label: "Status Explanations"
      },
      component: () => import("@/pages/settings/coach/StatusExplanationIndex.vue")
    },
    {
      path: "sub-course-programs",
      name: "sub-course-programs",
      meta: {
        label: "Program Sub Types",
      },
      component: () => import("@/pages/settings/sub-course-program/SubCourseProgramIndex.vue"),
    },
    {
      path: "task-settings",
      name: "task-settings",
      meta: {
        label: "Task Settings",
      },
      component: () => import("@/pages/settings/TaskSettings.vue")
    },
    {
      path: "universities",
      name: "other universities",
      meta: {
        label: "Universities",
      },
      component: () => import("@/pages/settings/UniversityIndex.vue"),
    }
  ]
};
